<ngb-carousel
    *ngIf="images?.length > 0"
    class="custom-carousel"
    [interval]="images.length === 1 ? 0 : 7000"
    [showNavigationArrows]="false"
    [showNavigationIndicators]="false"
    (slide)="onSlide($event)" 
>
    <ng-template
        ngbSlide
        *ngFor="let img of images; let i = index"
        [id]="'slide-' + i"
    >
        <img
            [src]="isMobile ? img.mobile : img.desktop"
            class="h-t-banner"
            (click)="onClick(i)"
            alt="Banner"
        />
    </ng-template>
</ngb-carousel>
